export const constants = {
  titles: [
    {
      title: '',
      className: 'extra-small'
    },
    {
      title: 'record',
      className: 'small'
    },
    {
      title: 'intro date',
      className: 'small'
    },
    {
      title: 'subject',
      className: 'small'
    },
    {
      title: 'date deleted',
      className: 'wide'
    },
    {
      title: 'comments',
      className: 'wide'
    },
    {
      title: '',
      className: 'small'
    }
  ],
  data: [
    {
      record: 'Pennsylvania 2011-2012 HB 1910',
      introDat: '10/4/2011',
      subject: 'Tort/Litigation Issues - P',
      dateDeleted: '11.22.2011 autumn.hoffman (Autumn.Hpffman@usaa.com)',
      comments: 'Title 40 Regulation of Health Plans - no need to follow'
    },
    {
      record: 'Pennsylvania 2011-2012 HB 1910',
      introDat: '10/4/2011',
      subject: 'Tort/Litigation Issues - P',
      dateDeleted: '11.22.2011 autumn.hoffman (Autumn.Hpffman@usaa.com)',
      comments: 'Title 40 Regulation of Health Plans - no need to follow'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/ManagementDeletedRecordsArchive/constants.js